import { dateFacetSetReducer as dateFacetSet } from '../../../../features/facets/range-facets/date-facet-set/date-facet-set-slice.js';
import { deselectAllDateFacetValues, registerDateFacet, toggleSelectDateFacetValue, updateDateFacetSortCriterion, updateDateFacetValues, toggleExcludeDateFacetValue, } from './date-facet-actions.js';
/**
 * Loads the `dateFacetSet` reducer and returns possible action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category DateFacetSet
 */
export function loadDateFacetSetActions(engine) {
    engine.addReducers({ dateFacetSet });
    return {
        deselectAllDateFacetValues,
        registerDateFacet,
        toggleSelectDateFacetValue,
        toggleExcludeDateFacetValue,
        updateDateFacetSortCriterion,
        updateDateFacetValues,
    };
}
